import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import DialogoConfirmacion from "./DialogoConfirmacion";
import ModalModificar from "./ModalModificar";
import "../Tabla.css";

const TablaUbicaciones = ({ datosTabla }) => {
  const [itemClicked, setItemClicked] = useState(undefined);

  const columns = [
    {
      name: "orden",
      label: "#",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "codigo",
      label: "Código",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      label: "Nombre ",
      name: "nombre",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "ambito",
      label: "Ámbito",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRender: (value) => <DialogoConfirmacion id={value} />,
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,

    responsive: "standard",
    searchPlaceholder: "Buscar ",
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    onRowsPerPageChange: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    download: false,
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
        sortable: true,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
        onPageChange: true,
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        downloadCsv: "Descargar",
      },

      viewColumns: {
        title: "Mostrar columnas",
      },

      TableHead: {
        root: {
          sortable: false,
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />
      {itemClicked && (
        <ModalModificar
          onHide={handleDeleteItemClicked}
          nombre={itemClicked.nombre}
          ambitoInicial={itemClicked.ambitoInicial}
          orden={itemClicked.orden}
          id={itemClicked.id}
          codigo={itemClicked.codigo}
          descripcion={itemClicked.descripcion}
          ambito={itemClicked.ambito}
        />
      )}
    </div>
  );
};

export default TablaUbicaciones;
